import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import TextInput from "../common/TextInput";
import TextAreaInput from "../common/TextAreaInput";
import Row from "../common/Row";
import DateInput from "../common/DateInput";
import AutoComplete from "../common/AutoComplete";
import SelectInput from "../common/SelectInput";
import Files from "../common/Files";
import { FileComponentNames } from "../../constants/ComponentConstants";
import { getPropertyFilesComponentProps } from "../../components/common/FilesHelperUtil";
import AdresWizard from "../adresWizard/adresWizard";

const InterneKlachtenForm = (props) => {
    const {
        klachtenModel,
		onAdresSave,
        onChange,
        onSave,
        onDropFiles,
        onRemoveFile,
        klachtenBronnen,
        fileDownloadUrl,
        filesComponent,
        errors
    } = props;

    const filesMimeTypes = 'application/vnd.ms-excel,application/msexcel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/png, image/jpeg, image/jpeg, image/gif, image/tiff';
    const filesExtensions = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';
    const filesProps = getPropertyFilesComponentProps("Bijlagen", FileComponentNames.KLACHTEN, fileDownloadUrl, filesComponent, null, false, onDropFiles, onRemoveFile, onChange, {
        mimeTypes: filesMimeTypes,
        extensions: filesExtensions
    });

    return (
        <Fragment>
            <Form
                name="klachten"
                onLeftButtonClick={onSave}
                leftButtonLabel={"Verzend"}
                isNotRequired
                headerVisible={false}>
                <div style={{ padding: "25px" }}>
                    <p style={{ margin: "10px" }}>Alle velden zijn verplicht tenzij anders aangegeven.</p>
                    <Row>
                        <TextInput
                            name="voornaam"
                            label="Voornaam"
                            value={klachtenModel.voornaam}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['voornaam'] : ""}
                        />
                        <TextInput
                            name="achternaam"
                            label="Achternaam"
                            value={klachtenModel.achternaam}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['achternaam'] : ""}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="klachtenOntvanger"
                            label="Naam medewerker die de klacht ontvangt"
                            value={klachtenModel.klachtenOntvanger}
                            onChange={onChange}
                            validationMessage={errors ? errors['klachtenOntvanger'] : ""}
                        />
                    </Row>
                    <br />
					<Row>
						<AdresWizard onSave={onAdresSave} model={klachtenModel.adres} errors={errors} />
					</Row>
					<br />
                    <Row>
                        <TextInput
                            name="organisatie"
                            label="Organisatie (optioneel)"
                            value={klachtenModel.organisatie}
                            onChange={onChange}
                            validationMessage={errors ? errors['organisatie'] : ""}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="telefoon"
                            label="Telefoon (optioneel)"
                            value={klachtenModel.telefoon}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['telefoon'] : ""}
                        />
                        <TextInput
                            name="gsm"
                            label="GSM (optioneel)"
                            value={klachtenModel.gsm}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['gsm'] : ""}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="email"
                            label="E-mail"
                            value={klachtenModel.email}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['email'] : ""}
                        />
                        <TextInput
                            name="bevestigEmail"
                            label="Bevestig e-mail"
                            value={klachtenModel.bevestigEmail}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['bevestigEmail'] : ""}
                        />
                    </Row>
                    <Row>
                        <DateInput
                            name="datum"
                            label="Datum"
                            value={klachtenModel.datum}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['datum'] : ""}
                        />
                    </Row>
                    <br />
                    <SelectInput
                        items={klachtenBronnen || []}
                        name="klachtenBron"
                        label="KlachtenBron"
                        value={klachtenModel.klachtenbron}
                        onChange={onChange}
                        validationMessage={errors ? errors['klachtenBron'] : ""}
                        size={12}
                        defaultItemVisible={false}
                    />
                    <TextAreaInput
                        name="omschrijving"
                        label="Omschrijving"
                        value={klachtenModel.omschrijving}
                        onChange={onChange}
                        height={5}
                        validationMessage={errors ? errors['omschrijving'] : ""}
                    />
                    <Files {...filesProps} />
                </div>
            </Form>
        </Fragment>
    );
};

InterneKlachtenForm.propTypes = {
    klachtenModel: PropTypes.object,
	onAdresSave: PropTypes.func,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onDropFiles: PropTypes.func,
    onRemoveFile: PropTypes.func,
    postcodes: PropTypes.array,
    gemeentes: PropTypes.array,
    klachtenBronnen: PropTypes.array,
    fileDownloadUrl: PropTypes.string,
    filesComponent: PropTypes.array,
    errors: PropTypes.array
};

export default InterneKlachtenForm;
